import React, { useRef, useState, useEffect } from "react";
import {
  Autocomplete,
  IconArrowDropDown,
  IconArrowDropUp,
  Input,
  KEY_VALUES,
  MenuListItem
} from "cdk-radial";

export default function SearchableDropdown(props: any) : JSX.Element {
  const targetRef:any = useRef();
  const dimensionRef = useRef();

  const [defaultOptions, setDefaultOptions] = useState(props.defaultOptions);
  const [options, setOptions] = useState(props.defaultOptions);
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const [clearButton, setClearButton] = useState(props.hasClearButton || true);

  useEffect(() => {
    setOptions(defaultOptions);
    setDefaultOptions(props.defaultOptions);
    setInputValue(props.selectedOption.label || ""); // Set inputValue when selectedOption changes
  }, [props.defaultOptions, isOpen, props.selectedOption]);

  useEffect(()=>{
    if(props.hasClearButton !== true){
        setClearButton(false);
    }else{
        setClearButton(true);
    }
  }, [props.hasClearButton]);


  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSelect = (option: any) => {
    setInputValue(option.label);
    props.setSelectedOption(option);
    handleClose();
    targetRef.current.focus();
  };

  const findOptions = (event:any) => {
    const inputText = event.target.value;
    setInputValue(inputText);
    setIsOpen(true);
    const textLength = inputText.length;
    const results = defaultOptions.filter((opt:any) => {
      return opt.label.toLowerCase().includes(inputText.toLowerCase());
    });
    setOptions(results);
    if (textLength === 0) {
      setOptions(defaultOptions);
    }
  };

  const handleClear = (event:any) => {
    event.preventDefault();
    setInputValue("");
    props.setSelectedOption({ label: "", value: "" });
    setOptions(defaultOptions);
  };

  const handleMenu = () => {
    setIsOpen(isOpen => !isOpen);
  };

  const handleKeyDown = (e:any) => {
    if (e.key === KEY_VALUES.ENTER) {
      if (inputValue.length > 0 && options.length > 0 && !options[0].disabled) {
        handleSelect(options[0]);
      }
    }
    if (e.key === KEY_VALUES.BACKSPACE && props.selectedOption.value !== "") {
      handleClear(e);
    }
    if (e.key === KEY_VALUES.TAB && props.selectedOption.value === "") {
      setInputValue("");
      setOptions(defaultOptions);
    }
  };
  return (
    <div>
      <div
        data-testid="autocomplete-menu"
        style={{ width: "97%" }}
      >
        <Input
          autoComplete="off"
          dataTestId="autocomplete-menu"
          icon={isOpen ? <IconArrowDropUp /> : <IconArrowDropDown />}
          id={props.id}
          label={props.label}
          labelRef={dimensionRef}
          name="typeahead-dropdown"
          onChange={findOptions}
          onClick={handleMenu}
          onInputClear={handleClear}
          onKeyDown={handleKeyDown}
          placeholder={props.placeHolder || "Search"}
          ref={targetRef}
          value={inputValue}
          size={props.size || "standard"}
          isRequired={props.isRequired || false}
          isDisabled={props.isDisabled || false}
          hasClearButton={clearButton}
        />
      </div>
      <Autocomplete
        dataTestId="autocomplete-menu"
        dimensionRef={dimensionRef}
        labelRef={targetRef}
        style={{ zIndex: "60" }}
        onClose={handleClose}
        onChange={findOptions}
        onOpen={handleOpen}
        isOpen={isOpen}
        onUnselect={props.selectedOption.label === ""}
      >
        {options.map((option: any, ind: any) => (
          <MenuListItem
            dataTestId={`autocomplete-menu-list-item-${ind}`}
            key={`${props.id}-${JSON.stringify(option)}`}
            isSelected={props.selectedOption.label === option.label}
            onClick={() => handleSelect(option)}
            isDisabled={option.disabled}
          >
            {option.label}
          </MenuListItem>
        ))}
      </Autocomplete>
    </div>
  );
};
